package com.vizio.redwolf.dms

import com.vizio.redwolf.dms.model.LinkedDevice
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
sealed class LinkedDevicesResponse {
    data class Success(val devices: List<LinkedDevice>) : LinkedDevicesResponse()
    data class Failure(val message: LinkedDevicesFailureMessage) : LinkedDevicesResponse()
    class Error(val exception: Throwable) : LinkedDevicesResponse()
    class Timeout(val exception: Throwable) : LinkedDevicesResponse()

    fun <R> fold (
        onSuccess: (Success: Success) -> R,
        onFailure: (Failure: Failure) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ) : R {
        return when (this) {
            is Success -> onSuccess(Success(this.devices))
            is Failure -> onFailure(Failure(this.message))
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}

@JsExport
@Serializable
data class LinkedDevicesFailureMessage(
    val message: String? = null,
    val responseCode: String? = null
)
